var map = {
	"./ciak.webp": 425,
	"./envelope.webp": 541,
	"./hotel.webp": 253,
	"./hourglass.webp": 29,
	"./italia.webp": 979,
	"./notes.webp": 802,
	"./plane.webp": 941,
	"./trolley.webp": 590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 574;